import { createGlobalStyle } from "styled-components"; // Prevents `body` from being scrollable.

export var PreventScrolling = createGlobalStyle(["body{overflow:hidden;}"]); // Similar to `PreventScrolling`, but intended to support legacy iOS Safari.
//
// `position: fixed` is required to support older versions of iOS Safari (pre-iOS 13, Sept 2019). The one pitfall is
// that window's scroll position will be reset to 0 when these styles are applied.

export var PreventScrollingLegacy = createGlobalStyle(["body{overflow:hidden;position:fixed;width:100%;}"]);